import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  chatMessage: [],
  threadChatMessage: [],
  threadChatMessageObj: {},
  isFetchingChatHistory: false,
  replyMessage: {},
  progress: "",
  progressThread: "",
  selectedFileName: [],
  selectedFileType: [],
  selectedFileNameThread: [],
  selectedFileTypeThread: [],
  imagePreviewOpen: false,
  imagePreviewData: {},
  userProfileId: "",
  userProfileHoverId: {},
  sidebarActiveData: {},
  loaderActiveData: false,
  searchChatData: "",
  attendeeData: {},
  deleteChatData: {},
  badWordList: [],
  loderAttendeeDirect: true,
  loaderAttendeeGroup: true,
  unreadChatMessage: [],
  socketData: null,
  isSocketConnected: false,
  groupList: [],
  attendeeList: [],
  chatRoom: "",
  searchAttendeeData: "",
  isUploadingData: [],
  attachmentData: [],
  deletedMessageIds: [],
  isCursorOnUserProfile: false,
  userProfilePopPosition: { x: 0, y: 0 },
  msgMentionUser: "",
  msgMentionId: "",
  isMentionInThread: false,
  isChatHistoryEnableOnce: false,
  selectedLanguage: "en",
  chatFilterLoader: false,
  popupClass: "",
  isScrollingUp: false,
  selectedReactionUser: {},
  recentlyUsedEmoticon: [],
  desktopSystemStats: {},
  userStaticInfo: {},
  chatSearchState: {},
  showPinnedMessage: false,
  pinnedChatMessages: [],
  loaderPinnedChatData: false,
  loaderMorePinnedChatMessage: false,
  hasMorePinnedChatMessage: true,
  showChatFiles: false,
  chatFiles: [],
  loaderChatFilesData: false,
  loaderMoreChatFiles: false,
  jumpTargetMessage: {},
  jumpTargetMessageThread: {},
  chatboardSelectedTab: "messages", // "pins" | "files" | "messages"
  loaderSearchChatMessage: false,
  searchedChatMessages: [],
  pinnedMessages: {},
  filesMessages: {},
  pinnedByUserProfileId: "",
  hasMoreChatFiles: true,
  // chatMessagesImagesIdsData: [],

  activeThreadChat: {}, //{ chatRoom: parentMessage}
  unreadThreadListObj: {}, // {chatRoom : unreadThreadList}

  //for phone support
  showPhoneSupport: false,
};
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatMessage: (state, action) => {
      state.chatMessage = action.payload;
    },
    setThreadChatMessage: (state, action) => {
      state.threadChatMessage = action.payload;
    },
    setThreadChatMessageObj: (state, action) => {
      state.threadChatMessageObj = action.payload;
    },
    setIsFetchingChatHistory: (state, action) => {
      state.isFetchingChatHistory = action.payload;
    },
    setReplyMessage: (state, action) => {
      state.replyMessage = action.payload;
    },
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    setProgressThread: (state, action) => {
      state.progressThread = action.payload;
    },
    setSelectedFileName: (state, action) => {
      state.selectedFileName = action.payload;
    },
    setSelectedFileType: (state, action) => {
      state.selectedFileType = action.payload;
    },
    setSelectedFileNameThread: (state, action) => {
      state.selectedFileNameThread = action.payload;
    },
    setSelectedFileTypeThread: (state, action) => {
      state.selectedFileTypeThread = action.payload;
    },
    setImagePreviewOpen: (state, action) => {
      state.imagePreviewOpen = action.payload;
    },
    setImagePreviewData: (state, action) => {
      state.imagePreviewData = action.payload;
    },
    setUserProfileId: (state, action) => {
      state.userProfileId = action.payload;
    },
    setUserProfileHoverId: (state, action) => {
      state.userProfileHoverId = action.payload;
    },
    setSidebarActiveData: (state, action) => {
      state.sidebarActiveData = action.payload;
    },
    setLoaderActiveData: (state, action) => {
      state.loaderActiveData = action.payload;
    },
    setSearchChatData: (state, action) => {
      state.searchChatData = action.payload;
    },
    setAttendeeData: (state, action) => {
      state.attendeeData = action.payload;
    },
    setMsgMentionUser: (state, action) => {
      state.msgMentionUser = action.payload;
    },
    setDeleteChatData: (state, action) => {
      state.deleteChatData = action.payload;
    },
    setBadWordList: (state, action) => {
      state.badWordList = action.payload;
    },
    setLoderAttendeeDirect: (state, action) => {
      state.loderAttendeeDirect = action.payload;
    },
    setLoderAttendeeGroup: (state, action) => {
      state.loaderAttendeeGroup = action.payload;
    },
    setUnreadChatMessage: (state, action) => {
      state.unreadChatMessage = action.payload;
    },
    setSocketData: (state, action) => {
      state.socketData = action.payload;
    },
    setIsSocketConnected: (state, action) => {
      state.isSocketConnected = action.payload;
    },
    setGroupList: (state, action) => {
      state.groupList = action.payload;
    },
    setAttendeeList: (state, action) => {
      state.attendeeList = action.payload;
    },
    setChatRoom: (state, action) => {
      state.chatRoom = action.payload;
    },
    setSearchAttendeeData: (state, action) => {
      state.searchAttendeeData = action.payload;
    },
    setIsUploadingData: (state, action) => {
      state.isUploadingData = action.payload;
    },
    setAttachmentData: (state, action) => {
      state.attachmentData = action.payload;
    },
    setDeleteMessage: (state, action) => {
      state.deletedMessageIds = action.payload;
    },
    setIsCursorOnUserProfile: (state, action) => {
      state.isCursorOnUserProfile = action.payload;
    },
    setUserProfilePopPosition: (state, action) => {
      state.userProfilePopPosition = action.payload;
    },
    setMsgMentionId: (state, action) => {
      state.msgMentionId = action.payload;
    },
    setIsMentionInThread: (state, action) => {
      state.isMentionInThread = action.payload;
    },
    setIsChatHistoryEnableOnce: (state, action) => {
      state.isChatHistoryEnableOnce = action.payload;
    },
    setSelectedLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
    },
    setChatFilterLoader: (state, action) => {
      state.chatFilterLoader = action.payload;
    },
    setPopupClass: (state, action) => {
      state.popupClass = action.payload;
    },
    setIsScrollingUp: (state, action) => {
      state.isScrollingUp = action.payload;
    },
    setSelectedReactionUser: (state, action) => {
      state.selectedReactionUser = action.payload;
    },
    setRecentlyUsedEmoticons: (state, action) => {
      state.recentlyUsedEmoticon = action.payload;
    },
    setDesktopSystemStats: (state, action) => {
      state.desktopSystemStats = action.payload;
    },
    setUserStaticInfo: (state, action) => {
      state.userStaticInfo = action.payload;
    },
    setChatSearchState: (state, action) => {
      state.chatSearchState = action.payload;
    },
    setShowPinnedMessage: (state, action) => {
      state.showPinnedMessage = action.payload;
    },
    setPinnedChatMessage: (state, action) => {
      state.pinnedChatMessages = action.payload;
    },
    setLoaderPinnedChatData: (state, action) => {
      state.loaderPinnedChatData = action.payload;
    },
    setLoaderMorePinnedChat: (state, action) => {
      state.loaderMorePinnedChatMessage = action.payload;
    },
    setHasMorePinnedChatMessage: (state, action) => {
      state.hasMorePinnedChatMessage = action.payload;
    },
    setShowChatFiles: (state, action) => {
      state.showChatFiles = action.payload;
    },
    setChatFiles: (state, action) => {
      state.chatFiles = action.payload;
    },
    setLoaderChatFilesData: (state, action) => {
      state.loaderChatFilesData = action.payload;
    },
    setLoaderMoreChatFiles: (state, action) => {
      state.loaderMoreChatFiles = action.payload;
    },
    setHasMoreChatFiles: (state, action) => {
      state.hasMoreChatFiles = action.payload;
    },
    setChatboardSelectedTab: (state, action) => {
      state.chatboardSelectedTab = action.payload;
    },
    setJumpTargetMessage: (state, action) => {
      state.jumpTargetMessage = action.payload;
    },
    setJumpTargetMessageThread: (state, action) => {
      state.jumpTargetMessageThread = action.payload;
    },
    setLoaderSearchChatMessage: (state, action) => {
      state.loaderSearchChatMessage = action.payload;
    },
    setSearchedChatMessages: (state, action) => {
      state.searchedChatMessages = action.payload;
    },
    addPinnedMessages: (state, action) => {
      const chatRoom = state.chatRoom;
      if (!state.pinnedMessages[chatRoom]) {
        state.pinnedMessages[chatRoom] = [];
      }
      state.pinnedMessages[chatRoom] = action.payload;
    },
    updatePinnedMessages: (state, action) => {
      const { chatRoom, data } = action.payload;
      state.pinnedMessages[chatRoom] = data;
    },
    addFilesMessages: (state, action) => {
      const chatRoom = state.chatRoom;
      if (!state.filesMessages[chatRoom]) {
        state.filesMessages[chatRoom] = [];
      }
      state.filesMessages[chatRoom] = action.payload;
    },
    updateFilesMessages: (state, action) => {
      const { chatRoom, data } = action.payload;
      state.filesMessages[chatRoom] = data;
    },
    setPinnedByUserProfileId: (state, action) => {
      state.pinnedByUserProfileId = action.payload;
    },
    setActiveThreadChat: (state, action) => {
      const value = action.payload;
      state.activeThreadChat[value.documentID] = value;
    },

    removeActiveThreadChat: (state, action) => {
      const documentID = action?.payload;
      delete state.activeThreadChat[documentID];
    },

    setUnreadThreadListObj: (state, action) => {
      state.unreadThreadListObj = action.payload;
    },

    removeUnreadThread(state, action) {
      const { chatRoom, parent_id } = action.payload;

      if (!state.unreadThreadListObj?.[chatRoom]) return;
      state.unreadThreadListObj[chatRoom] = state.unreadThreadListObj[
        chatRoom
      ].filter((item) => item.parent_id !== parent_id);
    },

    //for phone support
    setShowPhoneSupport: (state, action) => {
      state.showPhoneSupport = action.payload;
    },
  },
});

export default chatSlice.reducer;
export const {
  setChatMessage,
  setThreadChatMessage,
  setIsFetchingChatHistory,
  setReplyMessage,
  setProgress,
  setProgressThread,
  setSelectedFileName,
  setSelectedFileType,
  setSelectedFileNameThread,
  setSelectedFileTypeThread,
  setImagePreviewOpen,
  setImagePreviewData,
  setUserProfileId,
  setUserProfileHoverId,
  setSidebarActiveData,
  setLoaderActiveData,
  setSearchChatData,
  setAttendeeData,
  setMsgMentionUser,
  setDeleteChatData,
  setBadWordList,
  setLoderAttendeeDirect,
  setLoderAttendeeGroup,
  setUnreadChatMessage,
  setSocketData,
  setIsSocketConnected,
  setGroupList,
  setAttendeeList,
  setChatRoom,
  setSearchAttendeeData,
  setIsUploadingData,
  setAttachmentData,
  setDeleteMessage,
  setIsCursorOnUserProfile,
  setUserProfilePopPosition,
  setMsgMentionId,
  setIsMentionInThread,
  setIsChatHistoryEnableOnce,
  setSelectedLanguage,
  setChatFilterLoader,
  setPopupClass,
  setIsScrollingUp,
  setSelectedReactionUser,
  setChatMessagesImagesIdsData,
  setRecentlyUsedEmoticons,
  setDesktopSystemStats,
  setUserStaticInfo,
  setChatSearchState,
  setShowPinnedMessage,
  setPinnedChatMessage,
  setLoaderPinnedChatData,
  setLoaderMorePinnedChat,
  setShowChatFiles,
  setChatFiles,
  setLoaderChatFilesData,
  setLoaderMoreChatFiles,
  setChatboardSelectedTab,
  setJumpTargetMessage,
  setJumpTargetMessageThread,
  setLoaderSearchChatMessage,
  setSearchedChatMessages,
  addPinnedMessages,
  updatePinnedMessages,
  addFilesMessages,
  updateFilesMessages,
  setPinnedByUserProfileId,
  setHasMoreChatFiles,
  setHasMorePinnedChatMessage,
  setActiveThreadChat,
  removeActiveThreadChat,
  setThreadChatMessageObj,
  setUnreadThreadListObj,
  removeUnreadThread,
  setShowPhoneSupport,
} = chatSlice.actions;
